import type { InputCityProperties } from ".";
import { useCallback, useEffect, useState } from "react";
import { useAirportNameMap } from "./use-airport-name-map";

export const useFlightSearchInput = (
  items: InputCityProperties["items"] = [],
  selectedKey: InputCityProperties["selectedKey"],
  isOpen: boolean,
) => {
  const [inputValue, setInputValue] = useState("");

  const airportNameMap = useAirportNameMap(items);

  const resetInput = useCallback(() => {
    if (!selectedKey) {
      setInputValue("");
      return;
    }
    const selected = airportNameMap.get(selectedKey);
    if (!selected) {
      setInputValue("");
      return;
    }
    setInputValue(selected.name);
  }, [airportNameMap, setInputValue, selectedKey]);

  useEffect(() => {
    resetInput();
  }, [selectedKey, isOpen, resetInput]);

  return [inputValue, setInputValue] as const;
};
